// Export all images for use throughout the application
// Using public path references for Vite

// Logos
export const logo = '/images/logos/door.svg';
export const appHub = '/images/logos/app-hub.svg';
export const knowledgeHub = '/images/logos/knowledge-hub.svg';
export const prework = '/images/logos/prework.svg';
export const prosci = '/images/logos/prosci.svg';
export const proxima = '/images/logos/proxima.svg';
export const researchHub = '/images/logos/research-hub.svg';
export const instructorHub = '/images/logos/instructor-hub.svg';
export const prosciAiLogo = '/images/logos/prosci-ai-logo.svg';
export const changeCoach = '/images/logos/changecoach.svg';

// Icons - Navigation
export const trainer = '/images/icons/side-navigation/trainer.svg';
export const menu = '/images/icons/hamburger.svg';
export const search = '/images/icons/navigation/search.svg';
export const help = '/images/icons/help.svg';
export const bookmark = '/images/icons/navigation/bookmark.svg';
export const userPlaceholder = '/images/icons/account-full.svg';

// Icons - Gold variants
export const goldBookmark = '/images/icons/gold/bookmark.svg';

// Icons - Resources
export const download = '/images/icons/resources-download.svg';
export const video = '/images/icons/resources-video.svg';
export const proximaLink = '/images/icons/resources-proxima.svg';
export const researchHubLink = '/images/icons/resources-research-hub.svg';
export const view = '/images/icons/view.svg';

// Icons - AI
export const thumbsUp = '/images/icons/ai/thumbs-up.svg';
export const thumbsDown = '/images/icons/ai/thumbs-down.svg';
export const thumbsUpSelect = '/images/icons/ai/thumbs-up-select.svg';
export const thumbsDownSelect = '/images/icons/ai/thumbs-down-select.svg';
export const aiLogo = '/images/icons/ai/ai-logo.svg';
export const chat = '/images/icons/ai/chat.svg';
export const grow = '/images/icons/ai/grow.svg';
export const succeed = '/images/icons/ai/succeed.svg';
export const aiAvatar = '/images/icons/ai/ai-sparkle.svg';
export const send = '/images/icons/ai/send.svg';
export const sendDisabled = '/images/icons/ai/send-disabled.svg';
export const newChat = '/images/icons/ai/new-chat.svg';
export const aiLogoFull = '/images/icons/ai/ai-logo-full.svg';
export const library = '/images/icons/ai/library.svg';
export const doc = '/images/icons/ai/doc.svg';
export const pdf = '/images/icons/ai/pdf.svg';
export const ppt = '/images/icons/ai/ppt.svg';
export const xls = '/images/icons/ai/xls.svg';

// Icons - General
export const lock = '/images/icons/lock.svg';
export const noMatches = '/images/icons/no-matches.svg';
export const noSummary = '/images/icons/ai-no-summary.svg';
export const generatingSummary = '/images/icons/ai-generating-summary.svg';
export const betaSummary = '/images/icons/ai-beta.svg';
export const errorSummary = '/images/icons/ai-error.svg';
export const warning = '/images/icons/warning.svg';
export const checkmark = '/images/icons/checkmark.svg';
export const copy = '/images/icons/copy.svg';
export const clipboard = '/images/icons/clipboard.svg';
export const trash = '/images/icons/trash.svg';
export const stop = '/images/icons/stop.svg';
export const pencil = '/images/icons/pencil.svg';
export const attachment = '/images/icons/attachment.svg';
export const link = '/images/icons/link.svg';

// Portal specific
export const contact = '/images/portal/contact.svg';
export const contactSupport = '/images/portal/contact-support.svg';

// Favicons/PNGs
export const aiFavicon = '/images/logos/kaiya-favicon.png';

// Note: No default export - all images are exported as named exports above
// If you need fallback behavior, you can import specific images or use * as Images